import BaseReducer from "./BaseReducer";
import {
  getCurrentDateTime,
  getDatePart,
  getTimePart,
} from "../../components/helpers/datetime";

class EnforcementReducer extends BaseReducer {
  domain = "Enforcement";
  type = "View";

  initialState = {
    loadingTypes: false,
    typeOptions: [],
    officer: null,
    formData: {
      id: null,
      rowVersion: null,
      date: getDatePart(getCurrentDateTime()),
      time: getTimePart(getCurrentDateTime()),
      isGamblingRelated: null,
      officerTypeId: null,
      visitDetails: "",
      incidentNumber: "",
      comments: "",
    },
  };
}

const reducer = new EnforcementReducer();

export default reducer;
